import React, { useState, useRef, useEffect, useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'
import axios from 'axios'
import {
  Navbar,
  useTheme,
  Image
} from '@nextui-org/react'
import {
  Flex,
} from '@mantine/core'
import { useIntl } from 'react-intl'
import { useMediaQuery } from 'react-responsive'
import { ConnectWallet } from 'components/ConnectWallet'
import LangSelector from 'components/LangSelector'
import SocialLinks from 'components/SocialLinks'
import useRefresh from 'hooks/useRefresh'
import { templateId } from 'utils'

const Menu: React.FC = () => {
  const intl = useIntl()
  const { isDark } = useTheme()
  const isMobile = useMediaQuery({ query: `(max-width: 992px)` })
  const { slowRefresh } = useRefresh()

  const location = useLocation()
  const { pathname } = location

  const navbarToggleRef = useRef(null)
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false)
  const [activeMenu, setActiveMenu] = useState(
    window.location.href.split(`${window.location.origin}`)[1],
  )

  const handleSideMenu = (link) => {
    setActiveMenu(link)
    return isSideMenuOpen && navbarToggleRef?.current?.click()
  }

  const menuItems = useMemo(() => {
    const items = [
      {
        name: intl.formatMessage({ id: "home", defaultMessage: "Home" }),
        link: 'https://jinkoai.com/'
      },
      {
        name: intl.formatMessage({ id: "claim", defaultMessage: "iNFT Claim" }),
        link: '/claim'
      }
    ]
    return items
  }, [intl])

  // when time reach 3 feb then add new menu item
  useEffect(() => {
    async function checkTime() {
      const targetTime = Math.floor(new Date('2024-02-02T19:00:00+08:00').getTime() / 1000)

      try {
        const response = await axios.get('https://worldtimeapi.org/api/timezone/Asia/Kuala_Lumpur')
        const { data, status } = response

        if (status === 200) {
          const serverTime = new Date(data.unixtime).getTime()

          if (serverTime >= targetTime) {
            // check if menu item is already added
            const isExist = menuItems.some(item => item.name === intl.formatMessage({ id: "vesting", defaultMessage: "Token Claim" }))

            if (isExist) return

            menuItems.push({
              name: intl.formatMessage({ id: "vesting", defaultMessage: "Token Claim" }),
              link: '/vesting'
            })
          }
        }
      } catch (error) {
        console.error('Error fetching server time:', error)
      }
    }

    checkTime()
  }, [slowRefresh, intl, menuItems])

  return (
    <>
      <Navbar isBordered={isDark} disableShadow disableBlur variant="static" maxWidth="fluid"
        className="cs-navbar"
      >
        <Navbar.Brand>
          <Navbar.Toggle showIn="sm" aria-label="toggle navigation" autoFocus ref={navbarToggleRef}
            onChange={(isSelected) => setIsSideMenuOpen(isSelected)} />
          {
            isMobile ? null :
              <Link to="https://jinkoai.com/home">
                <Image
                  src="/images/jinko-logo.png"
                  alt="Whitelabel Image"
                  width="150px"
                />
              </Link>
          }
        </Navbar.Brand>
        {templateId === '2' ?
          <Navbar.Content hideIn="sm" className="upper-item-navbar">
            {menuItems.map((mItem) => (
              <Navbar.Link key={mItem.name} href={mItem.link} className={pathname.includes(mItem.link) ? "active" : ""}>
                {mItem.name}
              </Navbar.Link>
            ))}
          </Navbar.Content>
          : null
        }
        <Navbar.Content>
          {templateId === '2' ?
            <>
              <LangSelector />
              <ConnectWallet />
            </>
            :
            <Flex
              gap="xs"
              justify="center"
              align="center"
              direction="column"
              wrap="wrap"
            >
              {templateId === '1' ?
                <SocialLinks />
                :
                null
              }
              <Flex
                gap="md"
                justify="center"
                align="center"
                direction="row"
                wrap="wrap"
              >
                <LangSelector />
                <ConnectWallet />
              </Flex>
            </Flex>
          }
        </Navbar.Content>
        <Navbar.Collapse>
          {menuItems.map((item) => (
            <Navbar.CollapseItem key={item.name} isActive={item.link === activeMenu} css={{
              color: 'var(--whiteColor)',
              justifyContent: 'center',
            }}>
              <Link to={item.link} onClick={() => handleSideMenu(item.link)} className={pathname.includes(item.link) ? "active" : ""}>
                {item.name}
              </Link>
            </Navbar.CollapseItem>
          ))}
        </Navbar.Collapse>
      </Navbar>

      {isMobile ? null :
        <Navbar isBordered disableShadow disableBlur variant="static" height="50px" className="cs-navbar2">
          <Navbar.Content hideIn="sm">
            {menuItems.map((mItem) => (
              <Link key={mItem.name} to={mItem.link} className={pathname.includes(mItem.link) ? "active" : ""}>
                {mItem.name}
              </Link>
            ))}
          </Navbar.Content>
        </Navbar>
      }
    </>
  )
}

export default Menu